import ApiClient from './base/ApiClient';

const client = new ApiClient();

export async function listCustomerApiKeys() {
  const res = await client.get('/customer_api_keys');
  return res.data;
}

export async function createCustomerApiKey(name) {
  const res = await client.post('/customer_api_keys', name ? { name } : {});
  return res.data; // { id, api_key }
}

export async function revokeCustomerApiKey(id) {
  const res = await client.delete(`/customer_api_keys/${id}`);
  return res.data;
}

export async function refreshCustomerApiKey(id) {
  const res = await client.post(`/customer_api_keys/${id}/refresh`);
  return res.data; // { id, api_key }
}


